import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Divider } from '@mui/material';
import { Listing } from '../../graphql/generated';
import { useNavigate } from 'react-router';

interface ProductCardProps {
  listing: Listing;
  onAddToCart: (productId: string) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ listing }) => {
  const navigate = useNavigate();
  const minPrice = Math.min(...listing.variants.map(v => v.price || 0));
  const maxPrice = Math.max(...listing.variants.map(v => v.price || 0));

  const handleProductClick = (shopDomain: string, productId: string) => {
    // Extract the numeric part from the Shopify ID
    const numericProductId = productId.split('/').pop();

    // Navigate to the product details page
    navigate(`/listing/${numericProductId}`, { state: { shop_domain: shopDomain } });
  };

  let listingSizes: string[] | null = null;
  let listingColors: string[] | null = null;

  for (const option of listing.options) {
      if (option.name.toLowerCase() === "size") {
        listingSizes = option.values;
      }
      if (option.name.toLowerCase() === "color" || option.name.toLowerCase() === "style") {
        listingColors = option.values;
      }
  }


  return (
    <Card
     onClick={() => handleProductClick(listing.shop_domain, listing.id)}
      sx={{
        cursor: "pointer",
        width: 230, // Set fixed width
        height: 475, // Set fixed height
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between', // Space out content
        alignItems: 'center', // Center items
        overflow: 'hidden', // Prevent content overflow
        backgroundColor: '#f5f5f5',
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: '100%', // Fit width of the card
          height: 345, // Set fixed height for image
          objectFit: 'contain', // Ensure the entire image fits within the space
          backgroundColor: '#ffffff', // Optional: Add a light background
        }}
        image={listing.images[0]?.src || 'default-image-url'} // Default image if none are available
        alt={listing.images[0]?.altText || listing.title}
      />
      <CardContent sx={{ textAlign: 'center', backgroundColor: '#f5f5f5', height: 133, width:"100%" }}>
        
        <Divider />
        <Box sx={{ display: 'flex', height: '100%', width: '100%', 
            flexDirection: 'column',  // Sets vertical layout
            alignItems: 'center',  }}>
        <Box sx={{ marginBottom: 2 }} /> {/* Spacer */}

        {listing.vendor &&(
          <Typography
            variant="body1"
            fontWeight={"bold"}
            fontSize={11}
          >
            {listing.vendor}
          </Typography>
        )}
        {listing.title && (
          <Typography
            variant="body1"
            fontSize={11}
          >
              {listing.title}
          </Typography>
        )}


        <Box sx={{ display: 'flex', height: '100%' }} /> {/* Spacer */}

        <Box
          mt={1}
          sx={{
            display: 'flex',          // Enables Flexbox
            flexDirection: 'column',  // Sets vertical layout
            alignItems: 'center',     // Centers children horizontally
          }}
        >

          <Typography variant="caption" fontSize={11}>
            ${minPrice !== maxPrice ? `${minPrice} - ${maxPrice}` : `${minPrice}`}
          </Typography>
          {listingSizes && (
            <Typography variant="caption">
              {listingSizes.join(", ")}
            </Typography>
          )}
          {listingColors && (
            <Typography variant="caption">
              {listingColors.join(", ")}
            </Typography>
          )}
        </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
